// extracted by mini-css-extract-plugin
export default {"pointable":"eXWfl","toggleIcon":"SZ_Uq"};